<div class="arch-escort-wrapper">
    <div class="arch-escort-frame">
        <div class="arch-escort-frame-inner">
                <div class=" escort-title">
                        יום ליווי עם אדריכל
                        <div class="close" (click)="close()">X</div>
                </div>
        <div class="container">
                
            <div class="row">
                <div class="col-md-1 col-sm-0"></div>
                <div class="col-md-10">
                    <div class="row">
                        <!-- <div class="logo-escort">

                        </div> -->
                        
                        
                    </div>
                    <div class="row">
                        
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="escort-promo">
                                תכנון הדירה או המשרד כבר מאחוריכם ואתם מתקשים לקבל החלטה סופית של בחירות בחנויות השונות, אם זו: חנות הקרמיקה, חנות התאורה,
                                אצל חברת המטבחים, השיש ועוד. אני יכול לעזור לכם ולהצטרף אליכם ליום בחירות בחנויות השונות
                                שתבחרו ולעזור לכם גם בקבלת ההחלטות וגם אפילו להפוך עבורכם את היום הזה ליום של כיף!
                            </div>
                            <div class="escort-leave-your-details">השאר פרטים ליצירת קשר ואחזור אליך, 
                                <br />
                                גיל 
                                
                            </div>
                            <div class="escort-details">
                                <div class="escort-price-for-day">
                                    מחיר עבור יום ליווי*: 1,800 ₪ + מע"מ
                                </div>
                                <div class="small-text">
                                    תשלום יתבצע ביום הפגישה
                                </div>
                                <div class="small-text">
                                    *יום ליווי עד 7 שעות.
                                </div>
                                <div class="small-text">
                                    * השירות ניתן ללקוחות מאיזור השרון וגוש דן.
                                </div>



                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="escort-feilds-wrapper">
                                    <div class="col-sm-12 input-field">

                                            <input class="col-sm-12  input-field-spacial special-font" type="text" (keyup)="validateSpacificField($event, 0)" placeholder="שם*" [(ngModel)]="name">
            
                                            <div class="form-control-label alert-danger" *ngIf="fieldHasError[0]">עליך למלא שם</div>
                                        </div>
                                        <div class="col-sm-12 input-field">
                                            <input class="col-sm-12 input-field-spacial special-font" type="email" (keyup)="validateSpacificField($event, 2)" placeholder="אמייל*" [(ngModel)]="email"
                                            />
                                            <div class="form-control-label alert-danger" *ngIf="fieldHasError[2]">עליך למלא אימייל</div>
            
                                        </div>
                                        <div class="col-sm-12 input-field">
                                            <input class="col-sm-12 input-field-spacial special-font" type="email" 
                                            (keyup)="validateSpacificField($event, 3)" onpaste="return false"
                                            placeholder="אימות כתובת אמייל*" [(ngModel)]="emailCopy"
                                            />
                                            <div class="form-control-label alert-danger" *ngIf="fieldHasError[3]">עליך למלא אימות אימייל</div>
            
                                        </div>
                                        <div class="col-sm-12 input-field">
                                            <input class="col-sm-12 input-field-spacial special-font" type="tel" placeholder="מספר טלפון" [(ngModel)]="phone" />
                                        </div>
                            </div>
                            
                            
                            <div class="recaptcha-escort input-field" *ngIf="displayGoogleRobot">
                                <re-captcha class="recaptcha" (resolved)="resolved($event)" siteKey="{{recaptchaKey}}"></re-captcha>
                                <div class="form-control-label alert-danger" *ngIf="fieldHasError[2]"> אנא סמן ב-V את תיבת "אני לא רובוט" </div>


                            </div>
                            <div class="col-sm-12 input-field">
                                <input class="submit-btn-online" (click)="sendMail()" type="button" value="שלח בקשה" />
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

        </div>
    </div>
</div>

<div class="msg-wrapper" *ngIf="displaySucceedMsg || displayFailddMsg">
    <div *ngIf="displaySucceedMsg" class="success-msg">
        <span class="close-x-msg" (click)="displaySucceedMsg=false;">x</span>
    הודעתך נשלחה בהצלחה!</div>
<div *ngIf="displayFailddMsg" class="faild-msg">
        <span class="close-x-msg" (click)="displayFailddMsg=false;">x</span>
    אופס! התרחשה תקלה. ההודעה לא נשלחה. אנא נסה שוב מאוחר יותר</div>
</div>
